function cacheGet(k){try{const x=localStorage.getItem(k);if(!x)return null;const {v,exp}=JSON.parse(x);return Date.now()>exp?null:v;}catch{return null}}
function cacheSet(k,v,ttl=86400000){try{localStorage.setItem(k,JSON.stringify({v,exp:Date.now()+ttl}))}catch{}}

const deliveryProfiles = [];
let currencyCode = "";
let currencyDecimalPlaces = null;

function isOrderDetailPath(){
  const p = String(location.pathname || "");
  return /\/account\/orders\/[^/]+/.test(p);
}

function safeJson(v){try{return JSON.parse(v)}catch{return null}}
function cookieGet(name){
  const arr = document.cookie ? document.cookie.split(";") : [];
  for(let c of arr){
    c = c.trim();
    if(c.startsWith(name+"=")) return decodeURIComponent(c.substring(name.length+1));
  }
  return "";
}

function normalizeCountry(v){return String(v||"").trim().toUpperCase()}
function normalizeLang(v){return String(v||"").trim().replaceAll("_","-").toLowerCase()}

function effectiveCountryForLogic(){
  if(isOrderDetailPath()) return "KR";
  const raw = cookieGet("popupCrc");
  const parsed = raw ? safeJson(raw) : null;
  if(parsed && parsed.country_code) return normalizeCountry(parsed.country_code);
  const el = document.getElementById("country_code");
  return el && el.value ? normalizeCountry(el.value) : "";
}

function forceKRForOrderDetail(){
  if(!isOrderDetailPath()) return;
  const c = document.getElementById("country_code");
  if(c) c.value = "KR";
}

function observeCountryCode(){
  if(!isOrderDetailPath()) return;
  const c = document.getElementById("country_code");
  if(!c) return;

  const apply = () => { if(c.value !== "KR") c.value = "KR" };
  apply();

  const mo = new MutationObserver(apply);
  mo.observe(c, { attributes:true, attributeFilter:["value"] });

  c.addEventListener("input", apply);
  c.addEventListener("change", apply);

  try{ window.addEventListener("pageshow", apply); }catch(e){}
}

document.addEventListener("DOMContentLoaded", function(){
  forceKRForOrderDetail();
  observeCountryCode();
  initLocalization();
});

async function initLocalization(){
  await initDeliveryProfiles();

  try{
    const countryCodeInput = document.getElementById("country_code");
    const languageCodeInput = document.getElementById("language_code");

    const countryCode = effectiveCountryForLogic();
    if(!countryCode){
      console.error("Country code is missing or empty!");
      return;
    }

    if(countryCodeInput && isOrderDetailPath()) countryCodeInput.value = "KR";

    console.log("Initialization: Country Code:", countryCode);

    const resultArr = await deliveryOptionsForCurrentCountryZone(countryCode);

    const freeLimit = resultArr.find(r => Number(r.amt) === 0)?.minAmt ?? null;
    if(freeLimit != null) document.body.setAttribute("data-freelimit", String(freeLimit));

    console.log({resultArr});

    if(Array.isArray(resultArr) && resultArr.length > 0){
      const shippingTable = document.getElementById("shipping-table");
      const tableBody = shippingTable ? shippingTable.getElementsByTagName("tbody")[0] : null;

      if(tableBody){
        tableBody.innerHTML = "";

        resultArr.forEach((option) => {
          const crcSymbolEl = document.getElementById("crc_symbol");
          const crcSymbol = crcSymbolEl ? crcSymbolEl.value : "";

          const row = document.createElement("tr");
          const crcCode = option.currency;

          const methodCell = document.createElement("td");
          methodCell.textContent = option.name;

          const amountCell = document.createElement("td");
          const min = option.minAmt;
          const max = option.maxAmt;

          amountCell.textContent = max > 0
            ? `${crcSymbol} ${min} ${crcCode} - ${crcSymbol} ${max} ${crcCode}`
            : `${crcSymbol} ${min} ${crcCode} and up`;

          const costCell = document.createElement("td");
          costCell.textContent = Number(option.amt) === 0 ? "Free" : `${crcSymbol} ${option.amt} ${crcCode}`;

          row.appendChild(methodCell);
          row.appendChild(amountCell);
          row.appendChild(costCell);
          tableBody.appendChild(row);
        });

        shippingTable.style.display = "block";
      }
    }

    if(languageCodeInput && !languageCodeInput.value){
      languageCodeInput.value = "EN";
    }
  }catch(e){
    console.error("Error during initialization:", e);
  }
}

async function initDeliveryProfiles(){
  try{
    const res = await fetch("https://eyotfl3wwh.execute-api.ap-northeast-2.amazonaws.com/graphql",{
      method:"POST",
      headers:{ "Content-Type":"application/graphql" },
      body: MM_QUERY
    });
    const json = await res.json();
    const nodes = json?.data?.deliveryProfiles?.nodes || [];
    deliveryProfiles.push(...nodes);
  }catch(error){
    console.error("Error initializing delivery profiles:", error);
  }
}

function deliveryOptionsForCurrentCountryZone(countryCode){
  console.log("Fetching delivery options for:", countryCode);

  countryCode = String(countryCode || "").toUpperCase();
  const newShippingOptions = [];

  if(!deliveryProfiles.length) throw new Error("No delivery profiles available.");

  const general = deliveryProfiles[0];
  const locationGroupZones = general?.profileLocationGroups?.[0]?.locationGroupZones?.edges || [];

  for(const zone of locationGroupZones){
    const obj = zone?.node;
    const countries = obj?.zone?.countries || [];

    for(const country of countries){
      if(country?.code?.countryCode !== countryCode) continue;

      const methods = obj?.methodDefinitions?.edges || [];
      for(const method of methods){
        const node = method?.node;
        const rateProvider = node?.rateProvider;
        const conditions = node?.methodConditions || [];

        if(!rateProvider || !Object.prototype.hasOwnProperty.call(rateProvider,"price")) continue;
        if(!rateProvider.price) continue;

        const newObj = {
          minAmt: 0,
          maxAmt: 0,
          amt: Number(rateProvider.price.amount),
          currency: rateProvider.price.currencyCode,
          name: node?.name || ""
        };

        for(const cond of conditions){
          if(cond?.operator === "LESS_THAN_OR_EQUAL_TO") newObj.maxAmt = Number(cond?.conditionCriteria?.amount);
          else if(cond?.operator === "GREATER_THAN_OR_EQUAL_TO") newObj.minAmt = Number(cond?.conditionCriteria?.amount);
        }

        newShippingOptions.push(newObj);
      }
    }
  }

  return newShippingOptions;
}

const MM_QUERY = `query myy(
  $methodDefinitionsPageSize:Int=10
  $locationsPageSize:Int=4
  $locationGroupZonesCursor: String
  $locationGroupZonesPageSize:Int=50
  $locationsCursor:String
  $methodDefinitionsCursor: String
){
  shop { name }
  deliveryProfiles(first: 10) {
    nodes {
      id
      name
      profileLocationGroups {
        locationGroup {
          id
          locations(first: $locationsPageSize, after: $locationsCursor) {
            pageInfo { hasNextPage }
            edges { cursor node { name id } }
          }
        }
        locationGroupZones(first: $locationGroupZonesPageSize after: $locationGroupZonesCursor) {
          pageInfo { hasNextPage }
          edges {
            cursor
            node {
              methodDefinitions(first: $methodDefinitionsPageSize after: $methodDefinitionsCursor) {
                pageInfo { hasNextPage }
                edges {
                  cursor
                  node {
                    id
                    name
                    methodConditions {
                      id
                      field
                      operator
                      conditionCriteria {
                        ... on MoneyV2 { amount currencyCode }
                        ... on Weight { unit value }
                      }
                    }
                    rateProvider {
                      ... on DeliveryRateDefinition {
                        id
                        price { amount currencyCode }
                      }
                    }
                  }
                }
              }
              zone {
                id
                countries {
                  id
                  code { countryCode restOfWorld }
                }
              }
            }
          }
        }
      }
    }
  }
}`;
